import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConstrucaoVariaveisService} from './construcao-variaveis.service';
import {PontoFisicoService} from '../ponto-fisico/ponto-fisico.service';
import {NgxPaginationModule} from 'ngx-pagination';
import {PipesModule} from '../comum/filtros/pipes/pipes.module';
import {ComumModule} from '../comum/comum.module';
import {routing} from '../rotas';
import {CadastroDadoTransacionalComponent} from './cadastro-dado-transacional/cadastro-dado-transacional.component';
import {ConstrucaoVariaveisTabsetComponent} from './construcao-variaveis-tabset/construcao-variaveis-tabset.component';
import {ListarDadosTransacionaisComponent} from './listar-dados-transacionais/listar-dados-transacionais.component';
import {ListarVariaveisComponent} from './listar-variaveis/listar-variaveis.component';
import {ConstrucaoVariavelComponent} from './construcao-variavel/construcao-variavel.component';
import {FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingModule, ANIMATION_TYPES} from 'ngx-loading';
import { CalendarModule } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule.forRoot(),
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    CalendarModule
  ],
  declarations: [ConstrucaoVariaveisTabsetComponent, ListarDadosTransacionaisComponent, CadastroDadoTransacionalComponent,
  ConstrucaoVariavelComponent, ListarVariaveisComponent],
  exports: [ConstrucaoVariaveisTabsetComponent, ListarDadosTransacionaisComponent, CadastroDadoTransacionalComponent,
  ConstrucaoVariavelComponent, ListarVariaveisComponent],
  providers: [ConstrucaoVariaveisService, PontoFisicoService, CookieService]
})
export class ConstrucaoVariaveisModule {}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/construcao-variaveis/construcao-variaveis.module.ts